import Header from '../components/Header'
import Meta from '../components/Meta'

const TermsOfUse = () => {
  // page content
  const pageTitle = 'Terms Of Use'
  const pageDescription = 'welcome to react bootstrap template'

  return (
    <div>
      <Meta title={pageTitle}/>
      <Header head={pageTitle} description={pageDescription} />
    </div>
  )
}

export default TermsOfUse